import { pageNames } from '@atc/bonnet-paths';
import showContactDealerCreator from './creators/showContactDealerCreator';

export default showContactDealerCreator({
    namespace: pageNames.DEALER_DETAILS,
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
